import { Container, Row, Col } from 'react-bootstrap';
import Timeline from "./Timeline";
import FaqTextContent from "./FaqTextContent";
import "./FaqContentLayout.css";
import { check_date_time } from "../../helper_functions/timeline_helpers.js";

const FaqContentLayout = () => {
  
  const timeline_list = [
    {
      date_time: "Feb. 15th 2022",
      action:"Datasets posted",
      deadline_reached: check_date_time(2022, 2, 15, 17)
    },
    {
      date_time: "May 1st 2022",
      action:"Submissions due",
      deadline_reached: check_date_time(2022, 5, 1, 12)
    },
    {
      date_time: "May 24th - 25th 2022",
      action:"Results announced at ACIC 2022",
      deadline_reached: check_date_time(2022, 5, 24, 12)
    }
  ];

  return(
    <div id="faq-content-layout-wrapper">
      <Container fluid id="faq-content-layout">
        <Row>
          <Col 
            id="faq-cards"
            xs={12} 
            sm={12} 
            md="auto" 
            lg="auto"
          >
            <div id="faq-cards-sticky-box">
              <Row>
                <Col>
                  <Timeline timelines={timeline_list} />
                </Col>
              </Row>
            </div>
          </Col>
          <Col 
            id="faq-content" 
            xs={12}
            sm={12} 
            md={6} 
            lg={8}
          >
            <Row>
              <Col id="faq-layout-text-content-wrapper">
                <FaqTextContent />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqContentLayout;
